import { render } from "./NoticeToast.vue?vue&type=template&id=fa7727f4"
import script from "./NoticeToast.vue?vue&type=script&lang=js"
export * from "./NoticeToast.vue?vue&type=script&lang=js"

import "./NoticeToast.vue?vue&type=style&index=0&id=fa7727f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__